'use client'

export { LinkToDoc } from '../ui/LinkToDoc.js'
